import React from "react";
import { t } from "../../../components/CustomComponent.js";
import ICON from "../icons.js";
import { REVIEW_TIMELINE, maskPhone } from "../partner_option.js";

/* ============================================================================
 * PartnerDone — ขั้นที่ 4 : ส่งใบสมัครแล้ว รอผู้ดูแลระบบตรวจสอบ
 *
 * หน้าจบต้องตอบสามคำถามที่ผู้สมัครถามต่อทันที : ส่งไปแล้วจริงไหม · ต่อไปเกิดอะไร ·
 * ถ้าเรื่องเงียบจะทวงถามที่ไหน — จึงมีเลขที่ใบสมัคร แถบขั้นตอน และช่องทางติดต่อ
 *
 * ไม่มีปุ่มย้อนกลับไปแก้ เพราะใบสมัครเข้าคิวตรวจสอบไปแล้ว (ดู PartnerStepper)
 * ========================================================================== */
export default function PartnerDone({ form, refCode, onCopy }) {
  return (
    <div className="hm-pt-done">
      <span className="hm-pt-done__icon hm-ico">{ICON.check_circle}</span>
      <h2 className="hm-pt-done__title">{t("partner_done_title")}</h2>
      <p className="hm-pt-done__desc">{t("partner_done_desc")}</p>

      {/* เลขที่ใบสมัคร : ให้คัดลอกได้ในคลิกเดียว เพราะต้องเอาไปแจ้งตอนติดต่อสอบถาม */}
      <div className="hm-pt-done__ref">
        <span className="hm-pt-done__ref-label">{t("partner_done_ref")}</span>
        <b>{refCode}</b>
        <button type="button" className="hm-pt-link" onClick={() => onCopy(refCode)}>
          <span className="hm-ico">{ICON.copy}</span>
          {t("partner_done_copy")}
        </button>
      </div>

      <div className="hm-pt-track">
        {REVIEW_TIMELINE.map((step, i) => (
          <div key={step.key} className={`hm-pt-track__item ${i === 0 ? "is-done" : ""}`}>
            <span className="hm-pt-track__dot">
              {i === 0 ? <span className="hm-ico">{ICON.check}</span> : i + 1}
            </span>
            <div className="hm-pt-track__text">
              <b>{t(step.label)}</b>
              <span>{t(step.desc)}</span>
            </div>
          </div>
        ))}
      </div>

      {/* ย้ำช่องทางที่ผลจะถูกส่งกลับไป — อีเมลกับเบอร์ที่เพิ่งยืนยันไป */}
      <p className="hm-pt-done__contact">
        <span className="hm-ico">{ICON.mail}</span>
        {t("partner_done_contact").replace("{email}", form.email).replace("{phone}", maskPhone(form.phone))}
      </p>

      <div className="hm-pt-done__actions">
        <a className="hm-btn hm-btn--ghost" href="/">
          {t("partner_done_back")}
        </a>
        {/* ปุ่มหลักคือ "ติดตามสถานะ" ไม่ใช่ "ดูทรัพย์" — คนที่เพิ่งส่งใบสมัครสงสัยเรื่อง
            ผลของใบตัวเองก่อนเสมอ พ่วงเลขที่ใบสมัครไปให้เลยจะได้เหลือแค่พิมพ์อีเมล */}
        <a className="hm-btn hm-btn--primary" href={`/partner/status?code=${encodeURIComponent(refCode)}`}>
          <span className="hm-ico">{ICON.search}</span>
          {t("partner_done_track")}
        </a>
      </div>
    </div>
  );
}
